/* This factor adjusts the table's position and size to match the smaller screen of Handy compared to the iPad. */
/* Handy tables are 15.79% smaller than on the iPad (i.e., 84.21% of the original size). */
export const HANDY_SCALE_FACTOR = 0.8421;
